var isMatch = {};
export {
  isMatch as __exports
};
//# sourceMappingURL=isMatch.js.map
